import { Card, CardContent, CardHeader, CardTitle } from '../../components/ui/card';
import { BarChart, Bar, XAxis, YAxis, CartesianGrid, Tooltip, ResponsiveContainer } from 'recharts';
import { useAuth } from '../../providers/AuthProvider';
import { formatShortNumber } from '../../utils/number';
import { PipelineStage } from './types';

interface PipelineStatusProps {
  data: PipelineStage[];
}

export const PipelineStatus = ({ data }: PipelineStatusProps) => {
  const { userInfo } = useAuth();
  const currencySymbol = userInfo?.company_base_currency_symbol || '$';
  return (
    <Card className="rounded shadow p-4">
      <CardHeader className="pb-2">
        <CardTitle className="tracking-tight text-xl font-semibold mb-4 flex items-center justify-between">Pipeline Status</CardTitle>
      </CardHeader>
      <CardContent>
        <ResponsiveContainer width="100%" height={400}>
          <BarChart 
            data={data} 
            layout="vertical"
            barGap={0}
            barCategoryGap={40}
            margin={{ top: 10, right: 10, left: 10, bottom: 10 }}
          >
            <CartesianGrid strokeDasharray="3 3" stroke="#e5e7eb" />
            <XAxis 
              type="number" 
              axisLine={false} 
              tickLine={false}
              scale="linear"
              domain={[0, 'auto']}
              tickFormatter={(value) => formatShortNumber(Number(value))}
            />
            <YAxis 
              dataKey="stage" 
              type="category" 
              axisLine={false} 
              tickLine={false}
              width={100}
            />
            <Tooltip 
              content={({ active, payload, label }) => {
                if (active && payload && payload.length > 0) {
                  const data = payload[0].payload;
                  return (
                    <div className="bg-white p-3 border rounded-lg shadow-lg text-sm">
                      <p className="font-semibold text-slate-900 mb-1">{label}</p>
                      {['Enquiries', 'Opportunities'].includes(data.stage) ? (
                        <p className="text-slate-700">{`Count: ${data.count.toLocaleString()}`}</p>
                      ) : (
                        <>
                          <p className="text-slate-600 text-xs">{`Count: ${data.count.toLocaleString()}`}</p>
                          <p className="text-emerald-600 font-semibold text-base">{`${currencySymbol}${Number(data.value).toLocaleString(undefined,{minimumFractionDigits:2, maximumFractionDigits:2})}`}</p>
                        </>
                      )}
                    </div>
                  );
                }
                return null;
              }}
            />
            <Bar 
              dataKey="count"
              fill="#059669" 
              radius={[0, 4, 4, 0]} 
              name="Count" 
              minPointSize={20}
              barSize={20}
            />
          </BarChart>
        </ResponsiveContainer>
      </CardContent>
    </Card>
  );
};
